(function () {
    angular.module('MktzapApp.Controllers')
      .controller('ShowVersioningsController', ShowVersioningsController)
  
    ShowVersioningsController.$inject = ['NotificationService', 'VersioningService', 'LangService']
  
    function ShowVersioningsController (NotificationService, VersioningService, LangService) {
      var vm = this

      LangService
        .getPageLabels({ 'page': 'menu.master.versioning' })
        .$promise
        .then(function (data) {
          vm.labels = data.lang
        })

        loadVersioning() 

        function loadVersioning () {
          VersioningService
          .all()
          .$promise
          .then(function (data) {
            vm.versioningData = data;
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, vm.labels.errorToLoadVersioningData)
          })
        }
    }
})();